module.exports = __webpack_public_path__ + "static/media/TripleEggShakerFast.f61558e0.mp3";